/* sst-product.js — PDP gallery (arrows + drag/swipe + thumbs) and variant picker.
   Isolated widget. Supports multiple PDP sections on a page. */
(function () {
  function initPdp(root) {
    /* ---------------- GALLERY ---------------- */
    var stage = root.querySelector('[data-pdp-stage]');
    var track = root.querySelector('[data-pdp-track]');
    var slides = track ? Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var current = 0;

    function goTo(i) {
      if (!slides.length) return;
      current = Math.max(0, Math.min(i, slides.length - 1));
      track.style.transform = 'translateX(' + -current * 100 + '%)';
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === current); });
    }

    function goToMediaId(mediaId) {
      if (mediaId == null) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i); return; }
      }
    }

    if (track && slides.length) {
      var prev = root.querySelector('[data-pdp-prev]');
      var next = root.querySelector('[data-pdp-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10) || 0); });
      });

      /* Drag / swipe */
      var dragging = false, startX = 0, deltaX = 0;
      function down(x) { dragging = true; startX = x; deltaX = 0; track.style.transition = 'none'; stage.classList.add('is-dragging'); }
      function move(x) {
        if (!dragging) return;
        deltaX = x - startX;
        var pct = (deltaX / stage.offsetWidth) * 100;
        track.style.transform = 'translateX(' + (-current * 100 + pct) + '%)';
      }
      function up() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        stage.classList.remove('is-dragging');
        var threshold = stage.offsetWidth * 0.15;
        if (deltaX > threshold) goTo(current - 1);
        else if (deltaX < -threshold) goTo(current + 1);
        else goTo(current);
      }

      stage.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', up);

      stage.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
      stage.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      stage.addEventListener('touchend', up);

      /* Keyboard */
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(current - 1);
        else if (e.key === 'ArrowRight') goTo(current + 1);
      });
    }

    /* ---------------- VARIANTS ---------------- */
    var variantsEl = root.querySelector('[data-pdp-variants]');
    var jsonEl = root.querySelector('[data-pdp-variant-json]');
    if (!variantsEl || !jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var priceEl = root.querySelector('[data-pdp-price]');
    var enquireBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-enquire]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-opt-value]'));

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('.sst-pdp__opt').forEach(function (optEl) {
        var pos = parseInt(optEl.getAttribute('data-opt-position'), 10);
        var active = optEl.querySelector('.sst-pdp__pill.is-active');
        if (active) opts[pos - 1] = active.getAttribute('data-value');
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = matchVariant(opts);
      if (!v) return;

      /* price */
      if (priceEl) {
        priceEl.innerHTML = '<span class="sst-pdp__price-val">' + v.price_formatted + '</span>';
      }

      /* gallery image */
      goToMediaId(v.featured_media_id);

      /* enquiry context */
      enquireBtns.forEach(function (btn) {
        var base = btn.getAttribute('data-base-title') || '';
        var label = v.title && v.title !== 'Default Title' ? base + ' — ' + v.title : base;
        btn.setAttribute('data-enquire', label);
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var pos = pill.getAttribute('data-position');
        root.querySelectorAll('.sst-pdp__pill[data-position="' + pos + '"]').forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        update();
      });
    });

    update();
  }

  document.querySelectorAll('[data-pdp]').forEach(initPdp);
})();
